module.exports = __webpack_public_path__ + "media/img/scholarship_types/Average Academic Performance Scholarships-42e004f9faa87c268830f11328e71420.svg";